import { getVariantImage } from "../product";

export const dataMapper = (productData, ratings) => {
  return {
    product: {
      name: productData.name,
      images: productData.images,
      contentUrl: productData.media.catwalkUrl,
      startDateTime: productData.variants[0]?.price?.startDateTime,
    },
    offers: {
      price: productData.variants[0].price.current.value,
      currency: productData.variants[0].price.currency,
      isInStock: productData.isInStock,
      offers: productData.variants.map((variant) => ({
        price: variant.price.current.value,
        currency: variant.price.currency,
        isInStock: variant.isInStock,
        product: {
          name: productData.name,
          sku: variant.sku,
          color: variant.colour,
          image: getVariantImage(productData.images, variant).url,
          brand: {
            name: productData.brandName,
          },
        },
      })),
    },
    ratings: Object.keys(ratings)?.length > 0 ? ratings : undefined,
    reviews: ratings?.reviews || [],
  };
};
